import clsx from "clsx";
import { useT } from "../i18n";

// Tab-Id "presentations" heißt aus historischen Gründen so; UI-Label ist
// jetzt "Artifacts" (Bucket für Präsentation/Blog/Heygen — Phase 3, 2026-06-20).
// ID-Rename wäre größeres Risiko (localStorage / URL-Code) ohne Gewinn.
export type ProjectTabId = "chats" | "tasks" | "presentations" | "intake";

export default function ProjectTabs({
  active,
  onChange,
  showChats,
  showPresentations,
  showIntake,
  counts,
}: {
  active: ProjectTabId;
  onChange: (id: ProjectTabId) => void;
  showChats: boolean;
  showPresentations?: boolean;
  showIntake?: boolean;
  counts?: Partial<Record<ProjectTabId, number>>;
}) {
  const t = useT();
  const tabs: { id: ProjectTabId; label: string; visible: boolean }[] = [
    { id: "chats", label: t.shared.projektReiter.chats, visible: showChats },
    { id: "tasks", label: t.shared.projektReiter.aufgaben, visible: true },
    {
      id: "presentations",
      label: t.shared.projektReiter.artefakte,
      visible: showPresentations !== false,
    },
    // Intake: Rohsprache -> Board (Harness-v3 C4).
    { id: "intake", label: t.shared.projektReiter.intake, visible: showIntake !== false },
  ];
  return (
    // overflow-x-auto (analog Blog-/Settings-Tabs): bei schmalem Viewport
    // scrollen die Tabs horizontal statt zu stauchen; shrink-0 haelt die
    // Buttons auf voller Breite (defensiv, L-04).
    <div className="flex items-center gap-1 border-b border-border bg-surface px-4 overflow-x-auto">
      {tabs
        .filter((t) => t.visible)
        .map((t) => {
          const cnt = counts?.[t.id];
          return (
            <button
              key={t.id}
              onClick={() => onChange(t.id)}
              className={clsx(
                "relative shrink-0 whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors -mb-px",
                active === t.id
                  ? "text-brand-600 border-b-2 border-brand-600"
                  : "text-text-2 hover:text-text border-b-2 border-transparent"
              )}
            >
              {t.label}
              {cnt != null && cnt > 0 && (
                <span className="ml-1 text-[11px] text-text-3">{cnt}</span>
              )}
            </button>
          );
        })}
    </div>
  );
}
